import Layout from '../../Component/layout/main-layout'
import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Galleries } from '../../api/Queries/get'
import { Context } from '../../Store/context'
import layoutBgImg from '../../Images/layout/news.jpg'
import GlobalLayout from '../../Component/layout/global-layout'

const Gallery = () => {
  const { t, i18n } = useTranslation()
  const [pictures, setPictures] = useState([])
  const { showError } = useContext(Context);

  const getPictureName = (p) => {
    const currentLang = i18n.language;
    if (currentLang === 'ru') {
      return p?.rus_name;
    } else if (currentLang === 'en') {
      return p?.eng_name;
    }
    return p?.tkm_name;
  };

  useEffect(() => {
    const getNewsTable = async () => {
      try {
        const res = await Galleries()
        setPictures([...res].reverse())
      } catch (error) {
        showError(error.message);
      }
    }
    getNewsTable()
  }, [showError])


  return (
    <GlobalLayout
      title={`${t('photomaterials')} - ${t('supreme_court')} ${t('turkmenistan')}`}
      keywords="Galareya, Galareýa"
    >
      <div className='mb-20'>
        <Layout
          title={t('news')}
          page={t('photomaterials')}
          layoutBgImg={layoutBgImg}
        />
        <div className='mt-8 media'>

          <p className='mb-8 text-primary font-bold 
                      dark:text-dark-text text-2xl'>
            {t('photomaterials')}
          </p>

          <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3  
                        gap-2 rounded-2xl'>
            {pictures?.map((pic) => (
              <div className='relative' key={pic.id}>
                <Link to={`/images/${pic.id}`}>
                  <img
                    src={pic.images[0]?.image ? pic.images[0]?.image : ''}
                    alt="images"
                    className='w-full xl:h-72 rounded-2xl object-cover'
                  />
                  <div className="w-full absolute bottom-0 bg-gradient-to-t from-black 
                                   text-white px-5 pb-4 pt-8 flex  flex-col rounded-bl-2xl 
                                   rounded-br-2xl">
                    <span className="text-xs mb-2">{pic.date}</span>
                    <div className="flex justify-between items-center">
                      <p className="w-11/12 font-medium text-sm">{getPictureName(pic)}</p>
                      <div className="bg-black border-2 border-white w-7  h-7 flex 
                                        justify-center items-center relative">
                        <div className="absolute bottom-0.5 right-0.5  bg-black 
                                                    text-white text-xs border-2 border-white w-7
                                                    h-7 flex justify-center items-center"
                        >
                          {pic?.images?.length}
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </GlobalLayout>
  )
}

export default Gallery